'use client';

import dynamic from 'next/dynamic';

export const AutoVsOneHundred = dynamic(
  () => import('./AutoVsOneHundred')
);

export const WidthVsHeightDemo = dynamic(
  () => import('./WidthVsHeightDemo')
);
